var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"PageBackground"}),_c('div',{staticClass:"Screen",staticStyle:{"position":"relative","background":"#fff0"},attrs:{"id":"page"}},[_c('page-header'),_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"Screen"},[_c('router-view')],1),_c('page-footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }